/* PavCon, LLC Proprietary.All rights reserved 2022 */
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { switchMap, catchError, tap } from 'rxjs/operators';
import { AppActions } from '../app.reducer';
import { Injectable } from '@angular/core';
import { LocalStorageService } from '../../services/local-storage.service';
import { of, EMPTY } from 'rxjs';


const NAMESPACE = 'USER-LOCATION';

@Injectable()
export class AppEffects {

  constructor(
    private action$: Actions,
    private localStorage: LocalStorageService
  ) {
  }


  init$ = createEffect(() => {
    return this.action$.pipe(
      ofType(AppActions.INIT),
      switchMap(() => {
        try {
          const local = this.localStorage?.get(NAMESPACE);
          if (local && typeof local === 'object') {
            return of({ type: AppActions.SET_USER_LOCATION, payload: local });
          } else {
            return of({ type: AppActions.KEEP_CURRENT_STATE });
          }
        } catch (error) {
          console.error('Error in init$ effect:', error);
          return of({ type: AppActions.KEEP_CURRENT_STATE });
        }
      }),
      catchError((error) => {
        console.error('Fatal error in init$ effect:', error);
        return of({ type: AppActions.KEEP_CURRENT_STATE });
      })
    );
  });




  saveUserLocation$ = createEffect(() => {
    return this.action$.pipe(
      ofType(AppActions.SET_USER_LOCATION),
      tap((action: any) => {
        try {
          if (action?.payload && this.localStorage) {

            const existing = this.localStorage.get(NAMESPACE);
            const incoming = action.payload;

            const equalIgnoringTimestamp = existing &&
              typeof existing === 'object' &&
              existing.majcomUUID === incoming.majcomUUID &&
              existing.baseUUID === incoming.baseUUID &&
              existing.unitUUID === incoming.unitUUID &&
              existing.fileType === incoming.fileType;

            if (equalIgnoringTimestamp) return;
            this.localStorage.set(NAMESPACE, incoming);
          }
        } catch (error) {
          console.error('Error saving user-location to localStorage:', error);
        }
      }),
      catchError((error) => {
        console.error('Fatal error in saveUserLocation$:', error);
        return EMPTY;
      })
    );
  }, { dispatch: false });
}
/*Distribution Statement B. Distribution authorized to U.S. Government agencies only.PavCon, LLC Proprietary.All rights reserved.
     2020 WARNING: this file may contain export controlled information.*/
